import React, { useState } from "react";
import SidebarNav from "./SidebarNav";
import FiltersBar from "./FiltersBar";
import { DocsFiltersProvider } from "./filtersContext";

export type DocsLayoutProps = {
  children: React.ReactNode;
};

/**
 * Wrapper layout for documentation pages with sidebar and content area.
 */
const DocsLayout: React.FC<DocsLayoutProps> = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <DocsFiltersProvider>
      <div className="flex w-full bg-white dark:bg-gray-950">
        {/* Sidebar - desktop */}
        <aside className="hidden lg:block w-72 shrink-0 border-r border-gray-200 dark:border-gray-800 h-[calc(100vh-64px)] sticky top-16 overflow-y-auto bg-white dark:bg-gray-950">
          <SidebarNav onNavigate={() => setMobileOpen(false)} />
        </aside>

        {/* Sidebar - mobile drawer */}
        {mobileOpen && (
          <div className="fixed inset-0 z-40 lg:hidden">
            <div
              className="absolute inset-0 bg-black/40"
              onClick={() => setMobileOpen(false)}
            />
            <div className="absolute inset-y-0 left-0 w-80 bg-white dark:bg-gray-900 border-r border-gray-200 dark:border-gray-800 p-4 overflow-y-auto">
              <SidebarNav onNavigate={() => setMobileOpen(false)} />
            </div>
          </div>
        )}

        {/* Content */}
        <main className="flex-1 min-w-0">
          <div className="sticky top-16 z-20 bg-white/80 dark:bg-gray-900/80 backdrop-blur border-b border-gray-200 dark:border-gray-800 px-4 py-2 lg:hidden flex items-center justify-between">
            <button
              className="px-3 py-2 rounded border text-sm"
              onClick={() => setMobileOpen((v) => !v)}
            >
              Menu
            </button>
            <div className="text-sm font-medium">Docs</div>
          </div>
          <div className="px-4 lg:px-8 py-4">
            <FiltersBar />
            {children}
          </div>
        </main>
      </div>
    </DocsFiltersProvider>
  );
};

export default DocsLayout;
